import { IEventListeners, Event } from './Event';

let onNotificationEvent: Event<INotification> = new Event<INotification>();

export enum LogLevel {
  Error,
  Warning,
  Info,
  Verbose
}

export enum Category {
  Core,
  Sink,
  Transport
}

export interface INotification {
  level: LogLevel;
  category: Category;
  message: () => string;
}

/* Note to callers: Do not trigger telemetry events on these notifications, as doing so may
 * create an infinite loop of telemetry events. */
export function onNotification(): IEventListeners<INotification> {
  return onNotificationEvent;
}

export function logNotification(level: LogLevel, category: Category, message: () => string) {
  onNotificationEvent.fireEvent({ level, category, message });
}
